var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    [
      _c(
        "v-col",
        { staticClass: "pt-0 pb-5", attrs: { cols: "12" } },
        [
          _vm.loaderCertificate
            ? _c(
                "v-row",
                { staticClass: "mt-5 px-1" },
                _vm._l(2, function (item) {
                  return _c(
                    "v-col",
                    { key: item, staticClass: "pa-0", attrs: { cols: "6" } },
                    [
                      _c("v-skeleton-loader", {
                        staticClass: "mt-n3 rounded-md pa-2",
                        attrs: { transition: "fade-transition", type: "image" },
                      }),
                    ],
                    1
                  )
                }),
                1
              )
            : [
                !_vm.$helpers.hasPermission(["view_genericcertificate"])
                  ? _c(
                      "v-card",
                      { staticClass: "my-5", attrs: { flat: "" } },
                      [_c("PermissionDenied", { attrs: { isDetail: true } })],
                      1
                    )
                  : [
                      _c(
                        "v-row",
                        { attrs: { "no-gutters": "" } },
                        [
                          _c(
                            "v-col",
                            { staticClass: "py-0", attrs: { cols: "12" } },
                            [
                              _c(
                                "v-card",
                                { ref: "certificate", attrs: { flat: "" } },
                                [
                                  _c(
                                    "v-toolbar",
                                    {
                                      attrs: {
                                        color: "transparent",
                                        flat: "",
                                        height: "46",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-toolbar-title",
                                        {
                                          staticClass:
                                            "px-5 subtitle-2 grey-700--text font-weight-bold",
                                        },
                                        [
                                          _c(
                                            "v-row",
                                            {
                                              attrs: {
                                                "no-gutters": "",
                                                align: "center",
                                                justify: "space-between",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "subtitle-2 grey-700--text font-weight-bold d-flex align-center",
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        size: "16",
                                                        left: "",
                                                        color: "grey-700",
                                                      },
                                                    },
                                                    [_vm._v("mdi-stamper")]
                                                  ),
                                                  _vm._v("Certificado digital"),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c("v-spacer"),
                                      _c(
                                        "v-toolbar-items",
                                        [
                                          _c(
                                            "v-row",
                                            {
                                              staticClass: "mr-5",
                                              attrs: {
                                                align: "center",
                                                justify: "center",
                                              },
                                            },
                                            [
                                              _vm.$helpers.hasPermission([
                                                "add_genericcertificate",
                                              ])
                                                ? _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        outlined: "",
                                                        ripple: false,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.modalCertificate = true
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        { attrs: { left: "" } },
                                                        [_vm._v("mdi-upload")]
                                                      ),
                                                      _vm._v(
                                                        "Subir certificado"
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("v-divider"),
                                  _c(
                                    "v-card-text",
                                    { staticClass: "px-5 py-0" },
                                    [
                                      !_vm.certificatesList?.length
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass:
                                                "pb-0 pt-2 text-center",
                                            },
                                            [
                                              _c("v-empty-state", {
                                                staticClass: "pt-6 pb-2",
                                                attrs: {
                                                  type: "certificate",
                                                  customClass: "mt-1",
                                                  isFree: true,
                                                  title:
                                                    "Aún no tienes certificados",
                                                  height: 139,
                                                  "min-height": "160",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _c(
                                            "v-list",
                                            {
                                              staticClass:
                                                "v-list-form-2-actions transparent pa-0",
                                            },
                                            [
                                              _c(
                                                "v-row",
                                                { attrs: { "no-gutters": "" } },
                                                [
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "pa-0",
                                                      attrs: { cols: "7" },
                                                    },
                                                    [
                                                      _c(
                                                        "v-list-item",
                                                        { staticClass: "pa-0" },
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            {
                                                              staticClass:
                                                                "font-weight-semibold d-flex align-center",
                                                            },
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  attrs: {
                                                                    color:
                                                                      "grey-700",
                                                                    size: "14",
                                                                    left: "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-account"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                " Nombre "
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-list-item-subtitle",
                                                            {
                                                              staticClass:
                                                                "body-1 grey-500--text",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .certificatesList[0]
                                                                    ?.name
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-list-item",
                                                        { staticClass: "pa-0" },
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            {
                                                              staticClass:
                                                                "font-weight-semibold d-flex align-center",
                                                            },
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  attrs: {
                                                                    color:
                                                                      "grey-700",
                                                                    size: "14",
                                                                    left: "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-calendar-blank"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                " Validez "
                                                              ),
                                                              _vm
                                                                .certificatesList[0]
                                                                ?.date_end &&
                                                              _vm.dateIsBefore(
                                                                _vm
                                                                  .certificatesList[0]
                                                                  ?.date_end,
                                                                _vm.today
                                                              )
                                                                ? _c(
                                                                    "v-tooltip",
                                                                    {
                                                                      attrs: {
                                                                        color:
                                                                          "grey-background",
                                                                        right:
                                                                          "",
                                                                        "max-width":
                                                                          "280px",
                                                                        transition:
                                                                          "scale-transition",
                                                                      },
                                                                      scopedSlots:
                                                                        _vm._u(
                                                                          [
                                                                            {
                                                                              key: "activator",
                                                                              fn: function ({
                                                                                on,
                                                                              }) {
                                                                                return [
                                                                                  _c(
                                                                                    "v-icon",
                                                                                    _vm._g(
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            small:
                                                                                              "",
                                                                                            color:
                                                                                              "red",
                                                                                          },
                                                                                      },
                                                                                      on
                                                                                    ),
                                                                                    [
                                                                                      _vm._v(
                                                                                        "mdi-information"
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              },
                                                                            },
                                                                          ],
                                                                          null,
                                                                          false,
                                                                          1265787342
                                                                        ),
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "d-block px-3 py-2",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "El certificado digital está vencido. Para resolver el problema compra un nuevo certificado y súbelo a Axteroid."
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-list-item-subtitle",
                                                            {
                                                              staticClass:
                                                                "body-1 grey-500--text",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "desde el " +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "date"
                                                                    )(
                                                                      _vm
                                                                        .certificatesList[0]
                                                                        ?.date_start
                                                                    )
                                                                  ) +
                                                                  " hasta el " +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "date"
                                                                    )(
                                                                      _vm
                                                                        .certificatesList[0]
                                                                        ?.date_end
                                                                    )
                                                                  )
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-list-item",
                                                        { staticClass: "pa-0" },
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            {
                                                              staticClass:
                                                                "font-weight-semibold d-flex align-center",
                                                            },
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  attrs: {
                                                                    color:
                                                                      "grey-700",
                                                                    size: "14",
                                                                    left: "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-domain"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                " Emisor "
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-list-item-subtitle",
                                                            {
                                                              staticClass:
                                                                "body-1 grey-500--text",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .certificatesList[0]
                                                                    ?.issuer
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-list-item",
                                                        { staticClass: "pa-0" },
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            {
                                                              staticClass:
                                                                "font-weight-semibold d-flex align-center",
                                                            },
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  attrs: {
                                                                    color:
                                                                      "grey-700",
                                                                    size: "14",
                                                                    left: "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-pound-box-outline"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                " Serial "
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-list-item-subtitle",
                                                            {
                                                              staticClass:
                                                                "body-1 grey-500--text",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .certificatesList[0]
                                                                    ?.serial
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "pa-0",
                                                      attrs: { cols: "5" },
                                                    },
                                                    [
                                                      _c(
                                                        "v-list-item",
                                                        { staticClass: "pa-0" },
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            {
                                                              staticClass:
                                                                "font-weight-semibold d-flex align-center",
                                                            },
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  attrs: {
                                                                    color:
                                                                      "grey-700",
                                                                    size: "14",
                                                                    left: "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-card-account-details"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "generals.RUT"
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-list-item-subtitle",
                                                            {
                                                              staticClass:
                                                                "body-1 grey-500--text",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .certificatesList[0]
                                                                    ?.tax_id
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-list-item",
                                                        { staticClass: "pa-0" },
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            {
                                                              staticClass:
                                                                "font-weight-semibold d-flex align-center",
                                                            },
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  attrs: {
                                                                    color:
                                                                      "grey-700",
                                                                    size: "14",
                                                                    left: "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-id-card"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _vm._v(" ID "),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-list-item-subtitle",
                                                            {
                                                              staticClass:
                                                                "body-1 grey-500--text",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .certificatesList[0]
                                                                    ?.digest
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-list-item",
                                                        { staticClass: "pa-0" },
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            {
                                                              staticClass:
                                                                "font-weight-semibold d-flex align-center",
                                                            },
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  attrs: {
                                                                    color:
                                                                      "grey-700",
                                                                    size: "14",
                                                                    left: "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-email"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" Email "),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-list-item-subtitle",
                                                            {
                                                              staticClass:
                                                                "body-1 grey-500--text",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .certificatesList[0]
                                                                    ?.email
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-list-item",
                                                        { staticClass: "pa-0" },
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            {
                                                              staticClass:
                                                                "font-weight-semibold d-flex align-center",
                                                            },
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  attrs: {
                                                                    color:
                                                                      "grey-700",
                                                                    size: "14",
                                                                    left: "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-calendar-blank"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                " Fecha de subida "
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-list-item-subtitle",
                                                            {
                                                              staticClass:
                                                                "body-1 grey-500--text",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "dateTimeSecond"
                                                                  )(
                                                                    _vm
                                                                      .certificatesList[0]
                                                                      ?.created
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                _vm.otherCertificatesList?.length
                  ? _c(
                      "v-expansion-panels",
                      {
                        staticClass: "mt-5",
                        model: {
                          value: _vm.panelOtherCertificates,
                          callback: function ($$v) {
                            _vm.panelOtherCertificates = $$v
                          },
                          expression: "panelOtherCertificates",
                        },
                      },
                      [
                        _c(
                          "v-expansion-panel",
                          [
                            _c(
                              "v-expansion-panel-header",
                              { staticClass: "px-4 py-3" },
                              [
                                _c(
                                  "v-row",
                                  {
                                    attrs: {
                                      "no-gutters": "",
                                      align: "center",
                                      justify: "space-between",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "subtitle-2 grey-700--text font-weight-bold d-flex align-center",
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: {
                                              size: "16",
                                              left: "",
                                              color: "grey-700",
                                            },
                                          },
                                          [_vm._v("mdi-stamper")]
                                        ),
                                        _vm._v(
                                          "Certificado digital anteriores"
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-expansion-panel-content",
                              { staticClass: "px-0" },
                              [
                                _c("v-divider"),
                                _vm._l(
                                  _vm.otherCertificatesList,
                                  function (cert, index) {
                                    return _c(
                                      "v-col",
                                      {
                                        key: index,
                                        staticClass: "py-2",
                                        attrs: { cols: "12" },
                                      },
                                      [
                                        _c(
                                          "v-list",
                                          {
                                            staticClass:
                                              "v-list-form-2-actions transparent pa-0",
                                          },
                                          [
                                            _c(
                                              "v-row",
                                              { attrs: { "no-gutters": "" } },
                                              [
                                                _c(
                                                  "v-col",
                                                  {
                                                    staticClass: "pa-0",
                                                    attrs: { cols: "7" },
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-item",
                                                      { staticClass: "pa-0" },
                                                      [
                                                        _c(
                                                          "v-list-item-title",
                                                          {
                                                            staticClass:
                                                              "font-weight-semibold d-flex align-center",
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  color:
                                                                    "grey-700",
                                                                  size: "14",
                                                                  left: "",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "mdi-account"
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" Nombre "),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-list-item-subtitle",
                                                          {
                                                            staticClass:
                                                              "body-1 grey-500--text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(cert.name)
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-list-item",
                                                      { staticClass: "pa-0" },
                                                      [
                                                        _c(
                                                          "v-list-item-title",
                                                          {
                                                            staticClass:
                                                              "font-weight-semibold d-flex align-center",
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  color:
                                                                    "grey-700",
                                                                  size: "14",
                                                                  left: "",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "mdi-calendar-blank"
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" Validez "),
                                                            cert?.date_end &&
                                                            _vm.dateIsBefore(
                                                              cert?.date_end,
                                                              _vm.today
                                                            )
                                                              ? _c(
                                                                  "v-tooltip",
                                                                  {
                                                                    attrs: {
                                                                      color:
                                                                        "grey-background",
                                                                      right: "",
                                                                      "max-width":
                                                                        "280px",
                                                                      transition:
                                                                        "scale-transition",
                                                                    },
                                                                    scopedSlots:
                                                                      _vm._u(
                                                                        [
                                                                          {
                                                                            key: "activator",
                                                                            fn: function ({
                                                                              on,
                                                                            }) {
                                                                              return [
                                                                                _c(
                                                                                  "v-icon",
                                                                                  _vm._g(
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          small:
                                                                                            "",
                                                                                          color:
                                                                                            "red",
                                                                                        },
                                                                                    },
                                                                                    on
                                                                                  ),
                                                                                  [
                                                                                    _vm._v(
                                                                                      "mdi-information"
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ]
                                                                            },
                                                                          },
                                                                        ],
                                                                        null,
                                                                        true
                                                                      ),
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "d-block px-3 py-2",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "El certificado digital está vencido. Para resolver el problema compra un nuevo certificado y súbelo a Axteroid."
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-list-item-subtitle",
                                                          {
                                                            staticClass:
                                                              "body-1 grey-500--text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "desde el " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "date"
                                                                  )(
                                                                    cert.date_start
                                                                  )
                                                                ) +
                                                                " hasta el " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "date"
                                                                  )(
                                                                    cert.date_end
                                                                  )
                                                                )
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-list-item",
                                                      { staticClass: "pa-0" },
                                                      [
                                                        _c(
                                                          "v-list-item-title",
                                                          {
                                                            staticClass:
                                                              "font-weight-semibold d-flex align-center",
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  color:
                                                                    "grey-700",
                                                                  size: "14",
                                                                  left: "",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "mdi-domain"
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" Emisor "),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-list-item-subtitle",
                                                          {
                                                            staticClass:
                                                              "body-1 grey-500--text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                cert.issuer
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-list-item",
                                                      { staticClass: "pa-0" },
                                                      [
                                                        _c(
                                                          "v-list-item-title",
                                                          {
                                                            staticClass:
                                                              "font-weight-semibold d-flex align-center",
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  color:
                                                                    "grey-700",
                                                                  size: "14",
                                                                  left: "",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "mdi-pound-box-outline"
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" Serial "),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-list-item-subtitle",
                                                          {
                                                            staticClass:
                                                              "body-1 grey-500--text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                cert.serial
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-col",
                                                  {
                                                    staticClass: "pa-0",
                                                    attrs: { cols: "5" },
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-item",
                                                      { staticClass: "pa-0" },
                                                      [
                                                        _c(
                                                          "v-list-item-title",
                                                          {
                                                            staticClass:
                                                              "font-weight-semibold d-flex align-center",
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  color:
                                                                    "grey-700",
                                                                  size: "14",
                                                                  left: "",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "mdi-card-account-details"
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "generals.RUT"
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-list-item-subtitle",
                                                          {
                                                            staticClass:
                                                              "body-1 grey-500--text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                cert.tax_id
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-list-item",
                                                      { staticClass: "pa-0" },
                                                      [
                                                        _c(
                                                          "v-list-item-title",
                                                          {
                                                            staticClass:
                                                              "font-weight-semibold d-flex align-center",
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  color:
                                                                    "grey-700",
                                                                  size: "14",
                                                                  left: "",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "mdi-id-card"
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _vm._v(" ID "),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-list-item-subtitle",
                                                          {
                                                            staticClass:
                                                              "body-1 grey-500--text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                cert.digest
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-list-item",
                                                      { staticClass: "pa-0" },
                                                      [
                                                        _c(
                                                          "v-list-item-title",
                                                          {
                                                            staticClass:
                                                              "font-weight-semibold d-flex align-center",
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  color:
                                                                    "grey-700",
                                                                  size: "14",
                                                                  left: "",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "mdi-email"
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" Email "),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-list-item-subtitle",
                                                          {
                                                            staticClass:
                                                              "body-1 grey-500--text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(cert.email)
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-list-item",
                                                      { staticClass: "pa-0" },
                                                      [
                                                        _c(
                                                          "v-list-item-title",
                                                          {
                                                            staticClass:
                                                              "font-weight-semibold d-flex align-center",
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  color:
                                                                    "grey-700",
                                                                  size: "14",
                                                                  left: "",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "mdi-calendar-blank"
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(
                                                              " Fecha de subida "
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-list-item-subtitle",
                                                          {
                                                            staticClass:
                                                              "body-1 grey-500--text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm._f(
                                                                  "dateTimeSecond"
                                                                )(cert.created)
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm.otherCertificatesList?.length -
                                          1 !==
                                        0
                                          ? _c("v-divider", {
                                              staticClass: "mt-3",
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  }
                                ),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
          _vm.$store?.state?.auth?.account?.country === "CL"
            ? [
                _vm.numberingInitialLoading
                  ? _c(
                      "v-col",
                      { staticClass: "pa-0 mt-5", attrs: { cols: "12" } },
                      [
                        _c("v-skeleton-loader", {
                          staticClass: "rounded-md",
                          attrs: {
                            transition: "fade-transition",
                            type: "image",
                          },
                        }),
                      ],
                      1
                    )
                  : _c(
                      "v-card",
                      { staticClass: "mt-5", attrs: { flat: "" } },
                      [
                        _c(
                          "v-toolbar",
                          {
                            attrs: {
                              color: "transparent",
                              flat: "",
                              height: "46",
                            },
                          },
                          [
                            _c(
                              "v-toolbar-title",
                              {
                                staticClass:
                                  "px-5 subtitle-2 grey-700--text font-weight-bold",
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "subtitle-2 grey-700--text font-weight-bold d-flex align-center",
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          size: "16",
                                          left: "",
                                          color: "grey-700",
                                        },
                                      },
                                      [_vm._v("mdi-file-document-multiple")]
                                    ),
                                    _vm._v(
                                      _vm._s(_vm.$t("generals.Numeración"))
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _c("v-spacer"),
                            _c(
                              "v-toolbar-items",
                              [
                                _c(
                                  "v-row",
                                  {
                                    staticClass: "mr-4",
                                    attrs: {
                                      align: "center",
                                      justify: "center",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "mr-2",
                                        attrs: { outlined: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.getNumbering(
                                              _vm.numeringTab
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("v-img", {
                                          attrs: {
                                            contain: "",
                                            src: require(`@/assets/icon-update${
                                              _vm.$vuetify.theme.dark
                                                ? "-dark"
                                                : ""
                                            }.svg`),
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm.$store.state.auth.account.acc_id
                                      ? _c(
                                          "v-menu",
                                          {
                                            attrs: {
                                              "close-on-click": "",
                                              "close-on-content-click": "",
                                              "offset-y": "",
                                              width: "300",
                                              "nudge-bottom": 8,
                                              left: "",
                                              transition: "slide-y-transition",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function ({ on, attrs }) {
                                                    return [
                                                      _c(
                                                        "v-btn",
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              staticClass:
                                                                "mr-2",
                                                              attrs: {
                                                                outlined: "",
                                                                ripple: false,
                                                              },
                                                            },
                                                            "v-btn",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                left: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-cursor-pointer"
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(
                                                            "Solicitar folios "
                                                          ),
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                size: "20",
                                                                right: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-chevron-down"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              2044253215
                                            ),
                                          },
                                          [
                                            _c(
                                              "v-list",
                                              { staticClass: "pa-0" },
                                              [
                                                _c(
                                                  "v-list-item",
                                                  {
                                                    staticClass: "px-3",
                                                    attrs: {
                                                      "active-class":
                                                        "transparent",
                                                      ripple: false,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        ;(_vm.type =
                                                          "timbraje"),
                                                          (_vm.requestCafDialog = true)
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-item-title",
                                                      {
                                                        staticClass:
                                                          "body-2 d-flex align-center",
                                                      },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              color: "grey-700",
                                                              left: "",
                                                              small: "",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "mdi-file-sign"
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          " Para timbraje "
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-list-item",
                                                  {
                                                    staticClass: "px-3",
                                                    attrs: { ripple: false },
                                                    on: {
                                                      click: function ($event) {
                                                        ;(_vm.type =
                                                          "foliación de Factura X"),
                                                          (_vm.requestCafDialog = true)
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-item-title",
                                                      {
                                                        staticClass:
                                                          "body-2 d-flex align-center",
                                                      },
                                                      [
                                                        _c("img", {
                                                          staticClass: "mr-2",
                                                          attrs: {
                                                            src: require(`@/assets/icon-darkness-fx${
                                                              _vm.$vuetify.theme
                                                                .dark
                                                                ? "-dark"
                                                                : ""
                                                            }.svg`),
                                                            width: 16,
                                                          },
                                                        }),
                                                        _vm._v(
                                                          " Foliación de Factura X "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.$store.state.auth.account.acc_id
                                      ? _c(
                                          "v-menu",
                                          {
                                            attrs: {
                                              "close-on-click": "",
                                              "close-on-content-click": "",
                                              "offset-y": "",
                                              width: "300",
                                              "nudge-bottom": 8,
                                              left: "",
                                              transition: "slide-y-transition",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function ({ on, attrs }) {
                                                    return [
                                                      _c(
                                                        "v-btn",
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              attrs: {
                                                                outlined: "",
                                                                ripple: false,
                                                              },
                                                            },
                                                            "v-btn",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                left: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-file-plus"
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(
                                                            "Cargar folios "
                                                          ),
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                size: "20",
                                                                right: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-chevron-down"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              1713079426
                                            ),
                                          },
                                          [
                                            _c(
                                              "v-list",
                                              { staticClass: "pa-0" },
                                              [
                                                _c(
                                                  "v-list-item",
                                                  {
                                                    staticClass: "px-3",
                                                    attrs: {
                                                      "active-class":
                                                        "transparent",
                                                      ripple: false,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        ;(_vm.type =
                                                          "timbraje"),
                                                          (_vm.cafDialog = true)
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-item-title",
                                                      {
                                                        staticClass:
                                                          "body-2 d-flex align-center",
                                                      },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              color: "grey-700",
                                                              left: "",
                                                              small: "",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "mdi-file-sign"
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          " Para timbraje "
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-list-item",
                                                  {
                                                    staticClass: "px-3",
                                                    attrs: { ripple: false },
                                                    on: {
                                                      click: function ($event) {
                                                        ;(_vm.type =
                                                          "foliación de Factura X"),
                                                          (_vm.cafDialog = true)
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-item-title",
                                                      {
                                                        staticClass:
                                                          "body-2 d-flex align-center",
                                                      },
                                                      [
                                                        _c("img", {
                                                          staticClass: "mr-2",
                                                          attrs: {
                                                            src: require(`@/assets/icon-darkness-fx${
                                                              _vm.$vuetify.theme
                                                                .dark
                                                                ? "-dark"
                                                                : ""
                                                            }.svg`),
                                                            width: 16,
                                                          },
                                                        }),
                                                        _vm._v(
                                                          " Foliación de Factura X "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("v-divider"),
                        _c(
                          "v-card-text",
                          { staticClass: "pa-0" },
                          [
                            _c("v-divider"),
                            _c(
                              "v-tabs",
                              {
                                staticClass: "mt-n1",
                                attrs: {
                                  color: "grey-900",
                                  grow: "",
                                  height: "46",
                                  "slider-size": "3",
                                },
                                model: {
                                  value: _vm.numeringTab,
                                  callback: function ($$v) {
                                    _vm.numeringTab = $$v
                                  },
                                  expression: "numeringTab",
                                },
                              },
                              [
                                _c(
                                  "v-tab",
                                  {
                                    staticClass:
                                      "body-2 grey-700--text basic-tab",
                                    attrs: { exact: "", ripple: false },
                                  },
                                  [_vm._v("Activos")]
                                ),
                                _c(
                                  "v-tab",
                                  {
                                    staticClass:
                                      "body-2 grey-700--text basic-tab",
                                    attrs: { exact: "", ripple: false },
                                  },
                                  [_vm._v("Usados")]
                                ),
                              ],
                              1
                            ),
                            _vm.numberingLoading
                              ? _c(
                                  "v-col",
                                  {
                                    staticClass: "pa-0 mt-5",
                                    attrs: { cols: "12" },
                                  },
                                  [
                                    _c("v-skeleton-loader", {
                                      staticClass: "rounded-md",
                                      attrs: {
                                        transition: "fade-transition",
                                        type: "image",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm.numberingList?.length
                              ? [
                                  _c("v-data-table", {
                                    staticClass: "table-not-rounded",
                                    attrs: {
                                      headers: _vm.currentHeader.filter(
                                        ({ countries }) =>
                                          countries.includes(
                                            _vm.$store?.state?.auth?.account
                                              ?.country
                                          )
                                      ),
                                      items: _vm.numberingList,
                                      "hide-default-header": "",
                                      "disable-sort": "",
                                      "hide-default-footer": "",
                                      "items-per-page":
                                        _vm.numberingList?.length,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "header",
                                          fn: function ({
                                            props: { headers },
                                          }) {
                                            return [
                                              _c("VTableHeaders", {
                                                attrs: {
                                                  headers: headers,
                                                  sortable: false,
                                                },
                                              }),
                                              _c("v-divider", {
                                                staticStyle: {
                                                  "min-width": "100%",
                                                  position: "absolute",
                                                  "margin-top": "-6px",
                                                  "margin-left": "-5px",
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                        {
                                          key: `item.document_type`,
                                          fn: function ({ item }) {
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("nameDocumentsType")(
                                                      item.document_type
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          },
                                        },
                                        {
                                          key: `item.current`,
                                          fn: function ({ item }) {
                                            return [
                                              item.status !== "USR"
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(item.current)
                                                    ),
                                                  ])
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                        {
                                          key: `item.restantes`,
                                          fn: function ({ item }) {
                                            return [
                                              item.status !== "USR"
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.end -
                                                          item.current +
                                                          1
                                                      )
                                                    ),
                                                  ])
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                        {
                                          key: `item.created`,
                                          fn: function ({ item }) {
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("date")(item.created)
                                                  )
                                                ),
                                              ]),
                                            ]
                                          },
                                        },
                                        {
                                          key: `item.status`,
                                          fn: function ({ item }) {
                                            return [
                                              item.status === "USR"
                                                ? _c("span", [
                                                    _vm._v("Para timbraje"),
                                                  ])
                                                : _vm._e(),
                                              item.status === "ENA"
                                                ? _c("span", [
                                                    _vm._v(
                                                      "Foliación de Factura X"
                                                    ),
                                                  ])
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                        {
                                          key: `item.actions`,
                                          fn: function ({ item }) {
                                            return [
                                              _c(
                                                "v-menu",
                                                {
                                                  attrs: {
                                                    "close-on-click": "",
                                                    "close-on-content-click":
                                                      "",
                                                    "offset-y": "",
                                                    left: "",
                                                    "nudge-left": 10,
                                                    "nudge-bottom": 10,
                                                    transition:
                                                      "slide-y-transition",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function ({
                                                          on,
                                                          attrs,
                                                        }) {
                                                          return [
                                                            _c(
                                                              "v-btn",
                                                              _vm._g(
                                                                _vm._b(
                                                                  {
                                                                    staticClass:
                                                                      "mr-n4",
                                                                    attrs: {
                                                                      text: "",
                                                                      "x-small":
                                                                        "",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          _vm.current =
                                                                            item
                                                                        },
                                                                    },
                                                                  },
                                                                  "v-btn",
                                                                  attrs,
                                                                  false
                                                                ),
                                                                on
                                                              ),
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    attrs: {
                                                                      color:
                                                                        "grey-500",
                                                                      size: "24",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "mdi-dots-vertical"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                },
                                                [
                                                  _c(
                                                    "v-list",
                                                    { staticClass: "pa-0" },
                                                    [
                                                      _c(
                                                        "v-list-item",
                                                        {
                                                          staticClass: "px-3",
                                                          attrs: {
                                                            ripple: false,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.download(
                                                                item.caf,
                                                                `${item.document_type}-${item.start}-${item.end}`
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            {
                                                              staticClass:
                                                                "d-flex align-center body-1 grey-500--text",
                                                            },
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  attrs: {
                                                                    color:
                                                                      "grey-700",
                                                                    size: "20",
                                                                    left: "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-code-braces-box"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                "Descargar CAF"
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ]
                              : _c("v-empty-state", {
                                  staticClass: "pt-6 pb-2",
                                  attrs: {
                                    type: "documents",
                                    id: "documentos",
                                    customClass: "mt-1",
                                    isFree: true,
                                    title: `Aún no existe ${_vm.$t(
                                      "generals.numeración"
                                    )}`,
                                    height: 149,
                                    "min-height": "160",
                                  },
                                }),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c("VUpload", {
        attrs: { cafDialog: _vm.cafDialog, type: _vm.type },
        on: {
          "update:cafDialog": function ($event) {
            _vm.cafDialog = $event
          },
          "update:caf-dialog": function ($event) {
            _vm.cafDialog = $event
          },
          getList: function ($event) {
            return _vm.getNumbering(_vm.numeringTab)
          },
        },
      }),
      _c("VRequestCAF", {
        attrs: { requestCafDialog: _vm.requestCafDialog, type: _vm.type },
        on: {
          "update:requestCafDialog": function ($event) {
            _vm.requestCafDialog = $event
          },
          "update:request-caf-dialog": function ($event) {
            _vm.requestCafDialog = $event
          },
        },
      }),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "700",
            persistent: "",
            "no-click-animation": "",
            scrollable: "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.modalCertificate,
            callback: function ($$v) {
              _vm.modalCertificate = $$v
            },
            expression: "modalCertificate",
          },
        },
        [
          _c(
            "v-card",
            { attrs: { flat: "" } },
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "transparent",
                      attrs: { flat: "", height: "46" },
                    },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-500--text font-weight-semibold",
                        },
                        [_vm._v("Nuevo certificado digital")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: { click: _vm.clear },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "grey-500", size: "20" },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "px-5 py-4" },
                [
                  _c(
                    "v-list",
                    { staticClass: "v-list-form transparent pa-0" },
                    [
                      _c(
                        "v-list-item",
                        { staticClass: "pa-0" },
                        [
                          _c(
                            "v-list-item-title",
                            [
                              _vm._v(" Archivo del certificado "),
                              _c(
                                "v-tooltip",
                                {
                                  attrs: {
                                    color: "grey-background",
                                    right: "",
                                    transition: "scale-transition",
                                    "max-width": "200px",
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function ({ on }) {
                                        return [
                                          _c(
                                            "v-icon",
                                            _vm._g(
                                              {
                                                attrs: {
                                                  small: "",
                                                  color: "grey-700",
                                                },
                                              },
                                              on
                                            ),
                                            [_vm._v("mdi-information")]
                                          ),
                                        ]
                                      },
                                    },
                                  ]),
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "d-block px-3 py-2" },
                                    [
                                      _vm._v(
                                        "Asegúrate que el certificado digital tenga formato/extensión .p12"
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-list-item-subtitle",
                            [
                              _c("v-file-input", {
                                ref: "newCertificate.file",
                                attrs: {
                                  error: _vm.$v.newCertificate.file.$error,
                                  type: "file",
                                  accept: "application/x-pkcs12",
                                  prepend: "mdi-paper-clip",
                                  "background-color": "transparent",
                                  "hide-details": "",
                                  placeholder: "No se eligió ningún archivo",
                                  solo: "",
                                  flat: "",
                                  chips: "",
                                  dense: "",
                                },
                                model: {
                                  value: _vm.newCertificate.file,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.newCertificate, "file", $$v)
                                  },
                                  expression: "newCertificate.file",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item",
                        { staticClass: "pa-0" },
                        [
                          _c(
                            "v-list-item-title",
                            [
                              _vm._v(" Contraseña "),
                              _c(
                                "v-tooltip",
                                {
                                  attrs: {
                                    color: "grey-background",
                                    right: "",
                                    transition: "scale-transition",
                                    "max-width": "200px",
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function ({ on }) {
                                        return [
                                          _c(
                                            "v-icon",
                                            _vm._g(
                                              {
                                                attrs: {
                                                  small: "",
                                                  color: "grey-700",
                                                },
                                              },
                                              on
                                            ),
                                            [_vm._v("mdi-information")]
                                          ),
                                        ]
                                      },
                                    },
                                  ]),
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "d-block px-3 py-2" },
                                    [
                                      _vm._v(
                                        "La contraseña que ingresaste al comprar el certificado digital"
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-list-item-subtitle",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "8" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      error:
                                        _vm.$v.newCertificate.password.$error,
                                      type: "password",
                                      outlined: "",
                                      required: "",
                                      "single-line": "",
                                      dense: "",
                                      "hide-details": "",
                                    },
                                    model: {
                                      value:
                                        _vm.$v.newCertificate.password.$model,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.$v.newCertificate.password,
                                          "$model",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "$v.newCertificate.password.$model",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "py-2 px-5" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "", color: "grey-700" },
                      on: { click: _vm.clear },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        loading: _vm.$store.state.irs.createLoader,
                        color: "grey-900",
                      },
                      on: { click: _vm.createCertificate },
                    },
                    [_vm._v("Subir certificado")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }